/* Así funciona · Trapero Giratorio 360 con Balde Escurridor (770465), azul (el único color con foto real)
   Todo sale de la foto real galeria_1 (tiendas/nayhogar/funciona/trapero-giratorio-360-con-balde-escurridor/hacer.py):
   el balde con su canasto de acero y el trapero en el piso. La clienta lleva el trapero REAL (palo recortado + la
   cabeza con su plato y su microfibra) hasta el canasto; la mopa entra al canasto (el aro del canasto la tapa) y, con
   "mantén presionado", gira sobre el eje del canasto con desenfoque según la velocidad y suelta gotas contra la pared
   perforada: la microfibra pasa de mojada (los mismos píxeles más oscuros) a escurrida (la foto real). Al sacarlo vuelve
   a la foto real. Ficha: cabezal giratorio 360°, balde centrífugo para escurrir sin tocar la mopa, mango ajustable,
   mopa de repuesto. Sin pedal ni mecanismo que la foto no muestre. */
NHF.escena('trapero-giratorio-360-con-balde-escurridor', function (E) {
  const D = /*DATOS*/{"base":"fn-trapero-giratorio-360-con-balde-escurridor-base.webp","foto":"fn-trapero-giratorio-360-con-balde-escurridor-foto.webp","palo":{"src":"fn-trapero-giratorio-360-con-balde-escurridor-palo.webp","caja":[639,174,485,1073],"hub":[1078.0,1219.0]},"cabeza":{"src":"fn-trapero-giratorio-360-con-balde-escurridor-cabeza.webp","mojada":"fn-trapero-giratorio-360-con-balde-escurridor-cabeza-mojada.webp","caja":[764,1130,602,296],"centro":[1069.0,1245.0],"k":0.5504},"canasto":{"src":"fn-trapero-giratorio-360-con-balde-escurridor-canasto.webp","mojada":"fn-trapero-giratorio-360-con-balde-escurridor-canasto-mojada.webp","w":404,"h":197,"cx":506.0,"cy":828.0,"k":0.415,"rp":116.1,"rw":190.0},"boca":{"cx":506,"cy":785,"a":203,"b":83},"palo_canasto":{"hub":[506.0,804.6],"esc":0.9}}/*FIN*/;
  const S = E.lienzo({ w: 1600, h: 1600, vista: [170, 150, 1260, 1320], vistaMovil: [190, 170, 1220, 1270] });
  E.titulo('Escúrrelo [sin tocarlo].', 'Lleva el trapero al canasto de acero y mantén presionado: la mopa gira y suelta el agua.');
  E.conSonido();
  S.cargando(true);

  /* ---------- capas (todas de la foto real) ---------- */
  S.img(D.base, null, { z: 1, alt: 'Balde escurridor azul con su canasto de acero y el trapero' });
  const foto = S.img(D.foto, null, { z: 2 });
  foto.style.transition = 'opacity .25s linear';
  const cv = S.canvas([180, 420, 1240, 1020], { z: 3, res: 1 });
  const P = D.palo, HUB = P.hub, CB = D.cabeza, CN = D.canasto, BOCA = D.boca, PC = D.palo_canasto;
  const grupo = S.grupo(P.caja, { z: 4, pivote: HUB });
  S.img(P.src, P.caja, { en: grupo, alt: 'Trapero giratorio con su palo' });
  // zonas para agarrarlo: el palo (cápsula sobre su eje) y la cabeza (elipse), no el rectángulo entero
  const movil = () => window.innerWidth < 760;
  function agarre(css) { const s = E.el('span', 'tp-agarre'); s.style.cssText = 'position:absolute;pointer-events:auto;cursor:grab;touch-action:none;' + css; grupo.appendChild(s); return s; }
  const ej0 = [705, 300], ej1 = [1018, 1060];
  const ang = Math.atan2(ej1[1] - ej0[1], ej1[0] - ej0[0]) * 180 / Math.PI, largo = Math.hypot(ej1[0] - ej0[0], ej1[1] - ej0[1]);
  const G = movil() ? 120 : 76;
  const cx0 = (ej0[0] + ej1[0]) / 2 - P.caja[0], cy0 = (ej0[1] + ej1[1]) / 2 - P.caja[1];
  const agPalo = agarre('left:' + (cx0 - largo / 2) + 'px;top:' + (cy0 - G / 2) + 'px;width:' + largo + 'px;height:' + G + 'px;border-radius:' + G + 'px;transform:rotate(' + ang + 'deg)');
  const cb = CB.caja;
  const agCab = agarre('left:' + (cb[0] - P.caja[0]) + 'px;top:' + (cb[1] - P.caja[1]) + 'px;width:' + cb[2] + 'px;height:' + cb[3] + 'px;border-radius:50%');
  const I = {};
  E.cargar([D.base, D.foto, P.src, CB.src, CB.mojada, CN.src, CN.mojada]).then(r => {
    I.cab = r[3]; I.cabM = r[4]; I.can = r[5]; I.canM = r[6]; S.cargando(false);
  });

  /* ---------- estado ---------- */
  const ST = { fase: 'piso', seco: 0, w: 0, ang: 0, apretado: false, hasta: 0, hecho: false, baja: 0 };
  let pos = { dx: 0, dy: 0, s: 1 }; // traslado del aro (rótula) y escala del trapero
  const HUB_C = PC.hub, D_CAN = [HUB_C[0] - HUB[0], HUB_C[1] - HUB[1]];
  const NOTA = 'Acabas de trapear: la mopa está mojada. Incluye balde, trapero y mopa de repuesto; cabezal que gira 360° y mango ajustable.';
  E.pasos(['Lleva el trapero al canasto', 'Mantén presionado: el canasto lo escurre', 'Sácalo listo para trapear']);
  E.paso(0);
  const lect = E.lectura({ etiqueta: 'La mopa' }); lect.poner('Mojada');
  lect.querySelector('.nhf-lectura__v').style.fontSize = 'clamp(28px,3.2vw,42px)';
  const bLlevar = E.boton('Llévalo por mí', () => meter(), { icono: 'toca' });
  const bEscurrir = E.boton('Mantén presionado para escurrir', () => {}, { icono: 'gira', primario: true, clase: 'tp-escurrir' });
  bEscurrir.hidden = true; bEscurrir.style.touchAction = 'none'; bEscurrir.style.userSelect = 'none'; bEscurrir.style.webkitUserSelect = 'none';
  const bSacar = E.boton('Sácalo', () => sacar(), { icono: 'mano', primario: true, clase: 'tp-sacar' });
  bSacar.hidden = true;
  E.nota(NOTA);

  /* ---------- arrastrar el trapero real ---------- */
  function escalaPor(dy) { const k = E.clamp(-dy / (HUB[1] - HUB_C[1]), 0, 1); return 1 - (1 - PC.esc) * k; }
  const arr = E.arrastrable(grupo, {
    etiqueta: 'Trapero: arrástralo al canasto',
    limites: [P.caja[0] - 760, P.caja[1] - 560, P.caja[0] + P.caja[2] + 300, P.caja[1] + P.caja[3] + 120],
    extra: p => 'scale(' + escalaPor(p.dy).toFixed(4) + ')',
    alEmpezar() { if (ST.fase === 'piso') levantar(); },
    alMover(p) { if (ST.fase === 'aire') pos = { dx: p.dx, dy: p.dy, s: escalaPor(p.dy) }; },
    alSoltar(dest, p) {
      if (ST.fase !== 'aire') return;
      const hx = HUB[0] + p.dx, hy = HUB[1] + p.dy;
      if (Math.hypot(hx - HUB_C[0], hy - HUB_C[1]) < 340 || Math.hypot(p.dx, p.dy) < 10) meter();
      else volverAlPiso();
    },
    alTeclado() { meter(); }
  });
  grupo.style.pointerEvents = 'none';
  function moverGrupo(dx, dy, s) { pos = { dx, dy, s }; grupo.style.transition = 'none'; grupo.style.transform = 'translate3d(' + dx + 'px,' + dy + 'px,0) scale(' + s.toFixed(4) + ')'; }
  function levantar() { ST.fase = 'aire'; foto.style.opacity = 0; S.pista('Llévalo hasta el canasto', 'mano'); E.sonido.tono(700, .04, .02); }
  async function volverAlPiso() {
    ST.fase = 'anim';
    const a = Object.assign({}, pos);
    await E.animarP(450, k => moverGrupo(a.dx * (1 - k), a.dy * (1 - k), a.s + (1 - a.s) * k));
    ST.fase = 'piso'; S.pista('Arrastra el trapero hasta el canasto', 'mano');
  }
  // arco: sube por encima del canasto y baja adentro (la microfibra se aprieta contra la pared y el aro la tapa)
  async function meter() {
    if (ST.fase !== 'piso' && ST.fase !== 'aire') return;
    if (ST.fase === 'piso') levantar();
    ST.fase = 'anim'; bLlevar.hidden = true; S.pista(null);
    agPalo.style.pointerEvents = agCab.style.pointerEvents = 'none';
    const a = Object.assign({}, pos), arriba = [D_CAN[0], D_CAN[1] - 190];
    await E.animarP(Math.max(420, Math.hypot(arriba[0] - a.dx, arriba[1] - a.dy) * 0.9), k => {
      moverGrupo(E.lerp(a.dx, arriba[0], k), E.lerp(a.dy, arriba[1], k) - Math.sin(k * Math.PI) * 60, E.lerp(a.s, PC.esc, k));
    });
    ST.fase = 'bajando'; ST.baja = 0;
    await E.animarP(420, k => { ST.baja = k; moverGrupo(arriba[0], E.lerp(arriba[1], D_CAN[1], k), PC.esc); }, E.salida);
    ST.fase = 'canasto'; ST.baja = 1;
    E.sonido.tono(260, .07, .05); E.vibrar(10);
    E.paso(1);
    bEscurrir.hidden = false; zonaCanasto.style.pointerEvents = 'auto'; zonaCanasto.classList.add('is-pista');
    S.pista('Mantén presionado para escurrir', 'toca');
    S.camara([220, 560, 600, 420], 900);
  }

  /* ---------- escurrir: mantener presionado (o un toque = un giro corto) ---------- */
  const zonaCanasto = S.toque([BOCA.cx - BOCA.a, BOCA.cy - BOCA.b - 30, BOCA.a * 2, BOCA.b * 2 + 70], { etiqueta: 'Canasto: mantén presionado para escurrir', redonda: true, z: 52 });
  zonaCanasto.style.pointerEvents = 'none'; zonaCanasto.style.touchAction = 'none';
  let t0 = 0, ruido = null;
  function apretar(e) {
    if (ST.fase !== 'canasto' || ST.hecho) return;
    if (e && e.cancelable) e.preventDefault();
    ST.apretado = true; t0 = performance.now(); zonaCanasto.classList.remove('is-pista'); S.el.classList.add('is-tocado');
    if (!ruido && E.sonido.activo) ruido = E.sonido.ruido(0, 0.01, 520);
  }
  function soltar() {
    if (!ST.apretado) return;
    ST.apretado = false;
    if (performance.now() - t0 < 300) ST.hasta = performance.now() + 1600; // un toque: gira un momento
  }
  [bEscurrir, zonaCanasto].forEach(el => {
    el.addEventListener('pointerdown', apretar);
    el.addEventListener('pointerup', soltar); el.addEventListener('pointerleave', soltar); el.addEventListener('pointercancel', soltar);
    el.addEventListener('keydown', e => { if ((e.key === ' ' || e.key === 'Enter') && !ST.apretado) apretar(e); });
    el.addEventListener('keyup', e => { if (e.key === ' ' || e.key === 'Enter') soltar(); });
    el.addEventListener('contextmenu', e => e.preventDefault());
  });

  /* ---------- sacarlo: vuelve al piso escurrido (la foto real) ---------- */
  async function sacar() {
    if (ST.fase !== 'canasto' || ST.w > 0.5) return;
    bSacar.hidden = true; bEscurrir.hidden = true; zonaCanasto.style.pointerEvents = 'none';
    S.pista(null); S.camara(null, 800);
    if (ruido) { ruido.parar(); ruido = null; }
    const arriba = [D_CAN[0], D_CAN[1] - 190];
    ST.fase = 'subiendo';
    await E.animarP(380, k => { ST.baja = 1 - k; moverGrupo(arriba[0], E.lerp(D_CAN[1], arriba[1], k), PC.esc); }, E.suave);
    ST.fase = 'anim';
    await E.animarP(820, k => moverGrupo(E.lerp(arriba[0], 0, k), E.lerp(arriba[1], 0, k) - Math.sin(k * Math.PI) * 60, E.lerp(PC.esc, 1, k)));
    moverGrupo(0, 0, 1);
    ST.fase = 'listo'; foto.style.opacity = 1;
    E.paso(3); lect.poner('Escurrida');
    E.nota('Incluye balde, trapero y mopa de repuesto. Cabezal que gira 360° y mango ajustable.');
    E.listo('Escurrida sin tocarla con las manos: lista para seguir trapeando.', reiniciar);
  }

  /* ---------- dibujo: la cabeza real (en el piso, en el aire o girando en el canasto) y las gotas ---------- */
  const gotas = [], caen = [];
  const VUELTA = Math.PI * 2;
  function cabezaPiso(alfa) {
    if (!I.cab || alfa <= 0) return;
    const c = cv.ctx, b = CB.caja, s = pos.s, hx = HUB[0] + pos.dx, hy = HUB[1] + pos.dy;
    c.save(); c.translate(hx, hy); c.scale(s, s); c.translate(-HUB[0], -HUB[1]);
    c.globalAlpha = alfa;
    if (ST.seco < 1) c.drawImage(I.cabM, b[0], b[1], b[2], b[3]);
    if (ST.seco > 0) { c.globalAlpha = alfa * ST.seco; c.drawImage(I.cab, b[0], b[1], b[2], b[3]); }
    c.restore();
  }
  function cabezaCanasto(alfa, bajada) {
    if (!I.can || alfa <= 0) return;
    const c = cv.ctx, w = CN.w, h = CN.h, cx = CN.cx, cy = CN.cy - (1 - bajada) * 40;
    const caja = [cx - w / 2, cy - h / 2, w, h];
    c.save();
    c.beginPath(); c.ellipse(BOCA.cx, BOCA.cy, BOCA.a, BOCA.b, 0, 0, VUELTA); c.clip();
    const barrido = Math.min(Math.PI * 0.9, ST.w * (1 / 30) * 1.2);
    const n = ST.w > 0.4 ? Math.max(2, Math.min(18, Math.round(barrido / 0.05))) : 1;
    const op = { caja, centro: [cx, cy], inclinacion: 0, aplaste: CN.k, angulo: ST.ang, barrido, muestras: n };
    if (ST.seco < 1) E.fx.giro(cv, Object.assign({ img: I.canM, alfa }, op));
    if (ST.seco > 0) E.fx.giro(cv, Object.assign({ img: I.can, alfa: alfa * ST.seco }, op));
    // gotas que salen de la microfibra y pegan contra la pared perforada
    c.lineCap = 'round';
    for (let i = gotas.length - 1; i >= 0; i--) {
      const g = gotas[i];
      const k = g.t / g.vida; if (k >= 1) { gotas.splice(i, 1); continue; }
      const x = g.x + g.vx * g.t, y = g.y + g.vy * g.t, a = 0.34 * (1 - k);
      c.strokeStyle = 'rgba(232,242,250,' + a.toFixed(3) + ')'; c.lineWidth = g.r;
      c.beginPath(); c.moveTo(x - g.vx * 0.025, y - g.vy * 0.025); c.lineTo(x, y); c.stroke();
    }
    c.restore();
  }
  function emitirGotas(n) {
    for (let i = 0; i < n; i++) {
      const f = Math.random() * VUELTA, r = CN.rw * (0.8 + Math.random() * 0.12), v = 240 + Math.random() * 260;
      // salen tangentes al giro y hacia afuera, en el plano del canasto (aplastado por la vista)
      const ux = (-Math.sin(f) + Math.cos(f)) * 0.7, uy = (Math.cos(f) + Math.sin(f)) * 0.7;
      gotas.push({ x: CN.cx + Math.cos(f) * r, y: CN.cy + Math.sin(f) * r * CN.k, vx: ux * v, vy: uy * v * CN.k, t: 0, vida: 0.1 + Math.random() * 0.1, r: 1.6 + Math.random() * 1.8 });
    }
  }
  // gotas que caen de la mopa mojada mientras va en el aire
  function gotasAire(dt) {
    const c = cv.ctx;
    if ((ST.fase === 'aire' || ST.fase === 'anim') && ST.seco < 0.5 && Math.random() < dt * 6) {
      const s = pos.s, hx = HUB[0] + pos.dx, hy = HUB[1] + pos.dy, f = Math.random() * Math.PI;
      const px = CB.centro[0] + Math.cos(f) * 230, py = CB.centro[1] + 30 + Math.sin(f) * 110;
      caen.push({ x: hx + (px - HUB[0]) * s, y: hy + (py - HUB[1]) * s, vy: 80, t: 0 });
    }
    for (let i = caen.length - 1; i >= 0; i--) {
      const g = caen[i]; g.t += dt; g.vy += 1700 * dt; g.y += g.vy * dt;
      if (g.t > 0.45) { caen.splice(i, 1); continue; }
      c.fillStyle = 'rgba(226,237,246,' + (0.38 * (1 - g.t / 0.45)).toFixed(3) + ')';
      c.beginPath(); c.ellipse(g.x, g.y, 2.4, 2.4 + g.vy * 0.007, 0, 0, VUELTA); c.fill();
    }
  }
  function pintar(dt) {
    cv.limpiar();
    const f = ST.fase;
    if (f === 'piso' || f === 'aire' || f === 'anim') cabezaPiso(1);
    else if (f === 'bajando' || f === 'subiendo') {
      // al pasar el aro, la cabeza en el aire se apaga y queda la misma cabeza dentro del canasto
      const k = ST.baja;
      cabezaPiso(Math.max(0, 1 - k * 1.7));
      cabezaCanasto(Math.min(1, k * 1.5), k);
    } else if (f === 'canasto') cabezaCanasto(1, 1);
    gotasAire(dt);
  }
  E.bucle((t, dt) => {
    // velocidad del canasto: sube mientras se mantiene presionado, se frena sola y para en vuelta completa
    if (ST.fase === 'canasto') {
      const girando = ST.apretado || performance.now() < ST.hasta;
      if (girando) ST.w = Math.min(30, ST.w + dt * 16);
      else if (ST.w > 0) {
        ST.w = Math.max(0, ST.w - dt * 14);
        const resto = VUELTA - (ST.ang - Math.floor(ST.ang / VUELTA) * VUELTA);
        if (ST.w < 2.5) { ST.w = Math.min(ST.w, Math.sqrt(2 * 2.5 * resto) + 0.15); if (resto < 0.03 || ST.w < 0.06) { ST.ang = Math.round(ST.ang / VUELTA) * VUELTA; ST.w = 0; } }
      }
      ST.ang += ST.w * dt;
      gotas.forEach(g => { g.t += dt; });
      if (ST.w > 10 && ST.seco < 1) emitirGotas(Math.max(1, Math.round(ST.w / 5 * (1 - ST.seco * 0.85))));
      if (ST.w > 6) ST.seco = Math.min(1, ST.seco + dt * (ST.w / 30) * 0.42);
      if (ruido) ruido.volumen(ST.w > 0.5 ? 0.012 + ST.w * 0.0012 : 0);
      if (ST.w > 0.5) lect.poner(ST.seco >= 1 ? 'Escurrida' : 'Escurriendo', Math.round(ST.seco * 100) + ' %');
      else if (ST.seco >= 1 && !ST.hecho) {
        ST.hecho = true; lect.poner('Escurrida');
        E.paso(2); bEscurrir.hidden = true; bSacar.hidden = false; zonaCanasto.style.pointerEvents = 'none';
        if (ruido) { ruido.parar(); ruido = null; }
        S.pista('Ya quedó escurrida: sácalo', 'toca');
      } else if (ST.seco > 0 && ST.seco < 1 && !ST.apretado) lect.poner('A medias', Math.round(ST.seco * 100) + ' %');
    }
    pintar(dt);
  });

  function reiniciar() {
    E.noListo();
    Object.assign(ST, { fase: 'piso', seco: 0, w: 0, ang: 0, apretado: false, hasta: 0, hecho: false, baja: 0 });
    moverGrupo(0, 0, 1); foto.style.opacity = 1; gotas.length = 0; caen.length = 0;
    agPalo.style.pointerEvents = agCab.style.pointerEvents = 'auto';
    bLlevar.hidden = false; bEscurrir.hidden = true; bSacar.hidden = true; zonaCanasto.style.pointerEvents = 'none';
    lect.poner('Mojada'); E.paso(0); E.nota(NOTA);
    S.pista('Arrastra el trapero hasta el canasto', 'mano');
  }
  // al empezar: la foto real (su sombra en el piso) con la mopa mojada encima: los mismos píxeles, más oscuros
  S.pista('Arrastra el trapero hasta el canasto', 'mano');
});
